module.exports = __webpack_public_path__ + "media/img/logos/default-59cf837419f43aa95d722cb69472cb98.svg";